import './css/App.css';
import Header from './components/Header.js'
import Footer from './components/Footer.js'
import Content from './components/Content.js'
import { useState } from 'react';

function App() {
  const [viewOn, setViewState] = useState(false)
  const [image, setImage] = useState(null)
  
  const setOverlayState = (viewOn, image) => {
    setViewState(viewOn)
    setImage(image || null)
    document.body.classList.toggle('overlay-on', viewOn)
  }

  return (
    // eslint-disable-next-line
    <div className="App">
      <div className={viewOn ? 'overlay on' : 'overlay off'} onClick={() => setOverlayState(false)}>
        <div className={viewOn ? 'overlay-content on' : 'overlay-content off'}>
          { image && <img src={image} alt={`digital illustration`} /> }
        </div>
      </div>
      <Header viewOn={viewOn} image={image} setOverlayState={setOverlayState} />
      <Content viewOn={viewOn} setOverlayState={setOverlayState} />
      <Footer />
    </div>
  );
}

export default App;